module.exports = __webpack_public_path__ + "img/banner_home.33a60a62.jpg";